export default __webpack_public_path__ + "static/media/img5.de6c4808.jpg";